interface DrawerNavigationBypassState {
    pathname: string;
    createdAt: number;
}

const DRAWER_NAVIGATION_BYPASS_TTL_MS = 5000;

let pendingDrawerNavigationBypass: DrawerNavigationBypassState | null = null;

export const markDrawerNavigationBypass = (pathname: string) => {
    pendingDrawerNavigationBypass = {
        pathname,
        createdAt: Date.now(),
    };
};

export const consumeDrawerNavigationBypass = (pathname: string) => {
    if (!pendingDrawerNavigationBypass) {
        return false;
    }

    const isExpired = Date.now() - pendingDrawerNavigationBypass.createdAt > DRAWER_NAVIGATION_BYPASS_TTL_MS;
    const isMatchingPathname = pendingDrawerNavigationBypass.pathname === pathname;

    pendingDrawerNavigationBypass = null;

    return !isExpired && isMatchingPathname;
};
